import { Select as MuiSelect, Box, Button,Step, Divider, StepContent, StepLabel, Stepper, Typography, Paper, FormControlLabel, Switch, CircularProgress, Grid, Snackbar, Alert, styled, MenuItem, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, useTheme, SelectChangeEvent, Skeleton, FormControl, InputLabel } from '@mui/material';
import { Form, useFormLookups, ChosenThemeActionContext, useFormValidate, FormSubmitButton, FormsFeatureContext, AuthenticatedUserContext, IValidationError, InputOnlyField, Text, Numeric, Select, Checkbox, useFormMetadata } from '@ngt/forms';
import { ValidateOn, IFormSubmit, useFormState, useScopedField, Condition, ConditionMode } from '@ngt/forms-core';
import React, { useState } from 'react';
import * as Dtos from '../../api/dtos';
import { FC, useContext, useEffect, useRef } from 'react';
import AdminRegistrationSteps from './AdminRegistrationSteps';
import AdminNavigation from "./AdminNavigation";
import { useNavigate, useParams } from 'react-router-dom';
import client from '../../api/client';
import DeleteModal from '../common/DeleteModal';
import Invoice from '../registration/Invoice';
import { ASMHomePage } from '@/constants/constants';
import { useReactToPrint } from 'react-to-print';
import AdminRegistrationHome from './AdminRegistrationHome';
import { LoadingButton } from '@mui/lab';
import PackageProvider from '../registration/packages/PackageProvider';
import { AdminContext } from '@/contexts/AdminContext';
import PackageContext, { IPackageContext } from '@/contexts/PackageContext';
import RegistrationCostUpdater from '../RegistrationCostUpdater';
import { formSubmit } from '@servicestack/client';
import DeleteSponsorModal from '../common/DeleteSponsorModal';
import Loading from '../common/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faTrash } from '@fortawesome/pro-solid-svg-icons';
import ExtendedTableCell from '../common/ExtendedTableCell';
import ExpandingRegoTableRow from './ExpandingRegoTableRow';
import { Registration, RegistrationSort, RegistrationStatus, Session, SponsorableType } from '../../api/dtos';
import useRegistrations from '@/hooks/useRegistrations';
import { getFormRoute } from '@/utils/getComputedFormRoutes';
import useRegistrationDeskSessions from '@/hooks/useRegistrationDeskSessions';
import { AdminRoutes } from '@/constants/routes';
import { forEach, update } from 'lodash-es';
import useSponsorSessions from '@/hooks/useSponsorSessions';

const DelegateTypes = [
    "",
    "Delegate",
    "Staff",
    "Trade / Sponsor",
    "Guest Speaker"
];

const subscription = {
    value: true
};


const FreeRegistrationUpdater = () => {

    const {
        state: {
            value: sponsorLevel
        },
        context: {
            setValue: setSponsorLevel,
            getValue: getSponsorLevel
        }
    } = useScopedField<number>('sponsorLevel', subscription);

    const {
        state: {
            value: freeRegistrations
        },
        context: {
            setValue: setFreeRegistrations,
        }
    } = useScopedField<number>('freeRegistrations', subscription);

    const {
        state: {
            value: traineeAndEarlyCareerDay
        }
    } = useScopedField<boolean>('traineeAndEarlyCareerDay', subscription);

    const {
        state: {
            value: sponsoredGuestSpeaker
        }
    } = useScopedField<boolean>('sponsoredGuestSpeaker', subscription);

    const {
        state: {
            value: symposiums
        }
    } = useScopedField<boolean>('symposiums', subscription);

    const {
        state: {
            value: symposiumsAmount
        }
    } = useScopedField<number>('symposiumsAmount', subscription);

    const {
        state: {
            value: additionalFreeRegistrations
        }
    } = useScopedField<number>('additionalFreeRegistrations', subscription);


    useEffect(() => {

        let additional = 0;
        if (traineeAndEarlyCareerDay === true)
        {
            additional++;
        }
        if (symposiums === true)
        {
            additional++;
        }
        if (sponsoredGuestSpeaker === true)
        {
            additional+=2;
        }
        // if (symposiums === true && symposiumsAmount !== undefined && symposiumsAmount !== null )
        // {
        //     additional += symposiumsAmount;
        // }

        if (additionalFreeRegistrations) {
            additional += additionalFreeRegistrations;
        }

        switch(sponsorLevel)
        {
            case 1:
                
                setFreeRegistrations((0 + additional), true, true, true, false);
                break;
            case 2:
                setFreeRegistrations((1 + additional), true, true, true, false);
                break;
            case 3: 
                setFreeRegistrations((1 + additional), true, true, true, false);
                break;
            case 4:
                setFreeRegistrations((2 + additional), true, true, true, false);
                break;
            case 5: 
                setFreeRegistrations((3 + additional), true, true, true, false);
                break;
            case 6: 
                setFreeRegistrations((4 + additional), true, true, true, false);
                break;
            case 7: 
                setFreeRegistrations((6 + additional), true, true, true, false);
                break;
            default:
                setFreeRegistrations((0 + additional), true, true, true, false);
                break;
        }
    }, [sponsorLevel, traineeAndEarlyCareerDay, symposiums, symposiumsAmount, additionalFreeRegistrations, sponsoredGuestSpeaker])

    return null;
}

interface SponsorEventIdUpdaterProps {
    sponsorSessions: Session[] | undefined;
}

const SponsorEventIdUpdater: FC<SponsorEventIdUpdaterProps> = ({
    sponsorSessions
}) => {

    const {
        state: {
            value: sponsoredEarlyCareerId
        },
        context: {
            setValue: setSponsoredEarlyCareerId,
        }
    } = useScopedField<number>('sponsoredEarlyCareerId', subscription);

    const {
        state: {
            value: traineeAndEarlyCareerDay
        },
    } = useScopedField<boolean>('traineeAndEarlyCareerDay', subscription);

    useEffect(() => {
        if (traineeAndEarlyCareerDay === true)
        {
            setSponsoredEarlyCareerId(sponsorSessions?.find(s => s.sponsorableType === (SponsorableType.EarlyCareerDay as number))?.id ?? 0);
        }
        else {
            setSponsoredEarlyCareerId(null);
        }

    }, [sponsorSessions, sponsoredEarlyCareerId, traineeAndEarlyCareerDay])

    return null;
}

interface SymposiumSelectorProps {
    sponsorSessions: Session[] | undefined;
}

const SymposiumSelecter: FC<SymposiumSelectorProps> = ({
    sponsorSessions,
}) => {

    const {
        state: {
            value: sponsoredSymposiumId
        },
        context: {
            setValue: setSponsoredSymposiumId,
        }
    } = useScopedField<number>('sponsoredSymposiumId', subscription);

    const {
        state: {
            value: symposiums
        }
    } = useScopedField<boolean>('symposiums', subscription);

    return (
        <>
            <FormControl
                fullWidth
            >
                <InputLabel>Symposium</InputLabel>
                <MuiSelect
                    sx={{
                        width: '100%'
                    }}
                    label="Symposium"
                    variant="outlined"
                    disabled={symposiums !== true}
                    value={sponsoredSymposiumId as any ?? ""}
                    onChange={(e: SelectChangeEvent) => {
                        setSponsoredSymposiumId(Number.parseInt(e.target.value ?? 0));
                    } 
                }
                >
                    {
                        sponsorSessions?.map(s => {
                            if (s.sponsorableType === (SponsorableType.Symposium as number))
                            {
                                return <MenuItem key={s.id} value={s.id} selected>{s.name}</MenuItem>
                            }
                        }
                        )
                    }
                </MuiSelect>
            </FormControl>
        </>
    );
}


const AdminAddSponsor: FC = () => {

    const navigate = useNavigate();

    const theme = useTheme();

    const [registration, setRegistration] = useState<Registration | null>();

    const sessionData = useRegistrationDeskSessions();

    const handleRegistrationClick = (id: number) => {
        navigate(getFormRoute(AdminRoutes.ADMIN_REGISTRATION_BY_ID, id.toString()))
    }

    const handleDeleteRego = (rego: Registration) => {
        setRegistration(rego)
    }

    const setChosenTheme = useContext(ChosenThemeActionContext);

    const formMetadata = useFormMetadata(5);

    const {data:lookups} = useFormLookups(formMetadata, { revalidateOnFocus: false, refreshWhenOffline: false, })

    const validate: any = useFormValidate(formMetadata)

    useEffect(() => {
        setChosenTheme('light');
    }, [])

    const {serviceStackClient} = useContext(FormsFeatureContext);

    const [deleteSponsor, setDeleteSponsor] = React.useState<Dtos.Sponsor | undefined>();

    const [sponsor, setSponsor] = React.useState<Dtos.Sponsor | undefined>();

    const {registrations, loading} = useRegistrations(sponsor?.id);

    const params = useParams();

    const regId = params?.id;
    
    const {data: sponsorSessions, loading: sponsorSessionsLoading} = useSponsorSessions();
    
    const onSubmit:IFormSubmit<Dtos.Sponsor, IValidationError> = async (formState, formActions) => {
        if(!formState.value)
            return;
        
        try{
            const response = await serviceStackClient.post(new Dtos.PostSponsorSave({
                sponsor: formState.value
            }));
            formActions.setValue(response.sponsor);
            window.location.replace('/admin/sponsor');
        }
        catch(err){
            
        }
    }

    React.useEffect(() => {
        if (regId !== undefined) {
            client
                .get(new Dtos.SponsorGetSingleById({
                    id: parseInt(regId ? regId : ''),
                }))
                .then(response => {
                    setSponsor(response.data)
                })
                .catch((e) => {
                    
                });
        }
    }, [client, regId, setSponsor]);

    const handleDelete = () => {
        setDeleteSponsor(sponsor);
    };

    const handleClose = (refetch: boolean) => {
        setDeleteSponsor(undefined);
        if(refetch){
            window.location.replace('/admin/sponsor');
        }
    }

    const handleRegClose = (refetch: boolean) => {
        setRegistration(null);

        if (refetch) {
            location.reload();
        }
    }

    return (
        <>
        <AdminNavigation/>
        <DeleteSponsorModal 
            sponsor={deleteSponsor}
            handleModalClose={handleClose}
        />
        <DeleteModal 
            registration={registration}
            handleModalClose={handleRegClose}
        />
        <Box sx={{paddingLeft: '100px', paddingRight: '100px', paddingTop:'30px', paddingBottom:'30px'}}>
            <Paper elevation={2} sx={{padding:'40px', pb: 10}}>
                <Grid container spacing={1}>
                    <Grid 
                        item 
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={9}
                    >
                        <Typography fontFamily='Roboto' color='primary' fontSize='30pt'>Sponsor</Typography>
                    </Grid>




                    {
                        <>
                            <Grid 
                                item 
                                xs={12} 
                                sm={12}
                                md={12}
                                lg={6}
                                xl={3}
                                sx={{textAlign: 'right'}}
                            >
                                {sponsor && (
                                <Button 
                                    onClick={handleDelete}
                                    variant="contained"
                                    sx={{ml:2}}
                                >
                                    Delete
                                </Button>)}
                            </Grid>
                        </>
                    }
                </Grid> 


                
                {
                <Form
                    initialValue={sponsor ?? null}
                    debug={import.meta.env.DEV}
                    lookups={lookups}
                    onValidate={validate}
                    validateOn={ValidateOn.onChange}
                    onSubmit={onSubmit}
                >

                    {/* <FormDebugPopupButton /> */}
                    <AdminContext.Provider value={true}>
                    
                    <FreeRegistrationUpdater />

                    {
                        !sponsorSessionsLoading && (
                            <SponsorEventIdUpdater
                                sponsorSessions={sponsorSessions}
                            />
                        )
                    }
                    

                    <Grid 
                        item
                        xs={12}
                        sx={{
                            marginTop:"20px",
                        }}
                    >

                        {
                            sponsor?
                                <></>
                            :
                                <Grid  
                                    item
                                    xs={12}
                                    sx={{
                                        marginBottom:"20px",
                                    }}
                                    
                                >
                                    <Alert
                                        severity="info"
                                        icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                                    >
                                        Adding the sponsors email extension will ensure only registrations using the input email extension will be allowed to recieve the sponsors benefits. 
                                    </Alert>

                                </Grid>

                        }

                        <Grid 
                            container
                            spacing={4}
                        >
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Sponsor Name"
                                    propertyPath="sponsorName"
                                    component={Text}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                
                                <InputOnlyField
                                    label="Sponsor Level"
                                    propertyPath="sponsorLevel"
                                    component={Select}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Email Extension"
                                    propertyPath="emailExtension"
                                    component={Text}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Additional Email Extension One"
                                    propertyPath="additionalEmailExtensionOne"
                                    component={Text}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Additional Email Extension Two"
                                    propertyPath="additionalEmailExtensionTwo"
                                    component={Text}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                
                                <InputOnlyField
                                    label="Trainee And Early Career Day Sponsored"
                                    propertyPath="traineeAndEarlyCareerDay"
                                    component={Checkbox}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                
                                <InputOnlyField
                                    label="Sponsored a Guest Speaker"
                                    propertyPath="sponsoredGuestSpeaker"
                                    component={Checkbox}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Symposium Sponsored"
                                    propertyPath="symposiums"
                                    component={Checkbox}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>

                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >

                                <Condition
                                    condition={({ value }) => value?.symposiums === true}
                                    subscription={{value: true}}
                                    mode={ConditionMode.Enable}
                                >
                                    {
                                        sponsorSessionsLoading? 
                                            <Skeleton variant="rectangular" />
                                        :
                                        <SymposiumSelecter
                                            sponsorSessions={sponsorSessions}
                                        />
                                    }
                                </Condition>
                            </Grid>



                            {/* <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <Condition
                                    condition={({ value }) => value?.symposiums === true}
                                    subscription={{value: true}}
                                    mode={ConditionMode.Enable}
                                >
                                    <InputOnlyField
                                    label="Amount of Symposiums"
                                    propertyPath="symposiumsAmount"
                                    sx={{margin:"normal"}}
                                    component={Numeric}
                                />

                                </Condition>
                            </Grid> */}


                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Additional Free Registrations"
                                    propertyPath="additionalFreeRegistrations"
                                    component={Numeric}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Free Registrations"
                                    propertyPath="freeRegistrations"
                                    component={Numeric}
                                    sx={{margin:"normal"}}
                                    disabled
                                />
                            </Grid>
                            <Grid  
                                item
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <InputOnlyField
                                    label="Free Registrations Used"
                                    propertyPath="registrationsUsed"
                                    component={Numeric}
                                    sx={{margin:"normal"}}
                                    disabled
                                />
                            </Grid>
                            
                            
                        </Grid>
                    </Grid>

                    <FormSubmitButton variant="contained"
                        sx={{
                            float: "right",
                            marginTop:"20px",
                            marginBottom: "20px"
                        }}
                        >
                        Submit
                    </FormSubmitButton>

                    {
                        sponsor?
                        <Typography 
                            fontSize={30} 
                            color="secondary" 
                            mt={4} 
                            sx={{
                                marginTop:"100px", 
                                marginBottom: "20px"
                            }}>
                            <b>Current Registrations for {sponsor?.sponsorName}</b>
                        </Typography>
                        :
                        <></>
                    }
                    




                    {
                    sessionData?.loading ?
                        <Loading />
                    : !loading && (!registrations || registrations?.find(r => r.sponsorId === sponsor?.id) === undefined || sponsor === undefined) ?
                        sponsor?
                            <Alert
                                severity="info"
                                icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                            >
                                There are no registrations for {sponsor?.sponsorName}
                            </Alert>
                        :
                            <></>
                        :
                        <>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                Id
                                            </ExtendedTableCell>
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                DateAdded
                                            </ExtendedTableCell>
                                                    
                                            
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                Last Name
                                            </ExtendedTableCell>
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                First Name
                                            </ExtendedTableCell>
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                Institution
                                            </ExtendedTableCell>
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                Registration Type
                                            </ExtendedTableCell>
                                            
                                            <ExtendedTableCell
                                                justify="start"
                                            >
                                                Receipt No.
                                            </ExtendedTableCell>
                                            <ExtendedTableCell
                                                justify="center"
                                            >
                                                Total Cost
                                            </ExtendedTableCell>
                                                    
                                            <ExtendedTableCell
                                                justify="center"
                                            >
                                                Amount Owing
                                            </ExtendedTableCell>
                                            
                                            <ExtendedTableCell
                                                justify="center"
                                            >
                                                Delete
                                            </ExtendedTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            loading ?
                                                <Loading />
                                                :
                                                <>
                                                    {
                                                        <>
                                                            {
                                                                registrations && registrations?.map((registration) => {
                                                                    if (registration.sponsorId == sponsor?.id)
                                                                    {

                                                                        return <TableRow
                                                                            key={`registration-${registration.id}`}
                                                                            sx={{
                                                                                '&:last-child td, &:last-child th': { border: 0 },
                                                                                ":hover": {
                                                                                    cursor: 'pointer',
                                                                                    //backgroundColor: registration.sessionAttendance?.every(s => s.attendance !== true) ? noSessionsHover : registration.amountOwing === 0 ? theme.palette.grey[100] : errorLightHover
                                                                                },
                                                                                //backgroundColor: registration.sessionAttendance?.every(s => s.attendance !== true) ? noSessions : registration.amountOwing === 0 ? 'inherit' : errorLight 
                                                                            }}
                                                                            onClick={() => handleRegistrationClick(registration.id!)}
                                                                        >
                                                                            
                                                                            <TableCell>
                                                                                {registration.invoiceNumber}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {
                                                                                    registration?.enteredDate && new Date(registration.enteredDate).toLocaleDateString('en-GB')
                                                                                }
                                                                            </TableCell>
                                                                            
                                                                            <TableCell>
                                                                                {registration.lastName}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {registration.firstName}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {registration.institution}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {DelegateTypes[registration.delegateType ?? 0]}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {registration.payments?.length! > 0 ? registration.payments?.[0].receiptNumber : "N/A"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                sx={{
                                                                                    textAlign: 'center'
                                                                                }}
                                                                            >
                                                                                {`$${registration.cost ?? "0"}`}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                sx={{
                                                                                    textAlign: 'center'
                                                                                }}
                                                                            >
                                                                                {`$${registration.amountOwing ?? registration.cost ?? "0"}`}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={event => {
                                                                                    handleDeleteRego(registration);
                                                                                    event.stopPropagation();
                                                                                }}
                                                                                sx={{
                                                                                    textAlign: 'center',
                                                                                    color: theme.palette.primary.main,
                                                                                    '&:hover':{
                                                                                        color: theme.palette.secondary.main,
                                                                                        backgroundColor: theme.palette.grey[300]  
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon size="lg" fixedWidth icon={faTrash} />
                                                                            </TableCell>
                                                                        </TableRow>

                                                                        
                                                                    }
                                                                })
                                                            }
                                                        </>
                                                    }
                                                </>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    }
                    </AdminContext.Provider>
                </Form>
                }           
            </Paper>
        </Box>

        </>
    )
}

export default AdminAddSponsor;
